import Vue from 'vue'
import App from './App.vue'
import router from './router'
import Toaster from 'v-toaster'
import 'v-toaster/dist/v-toaster.css'
import axios from 'axios'
// import moshaToast from 'mosha-vue-toastify'
// import 'mosha-vue-toastify/dist/style.css'

import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue'

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import './assets/main.css'
import vuetify from './plugins/vuetify'
import * as VueGoogleMaps from 'vue2-google-maps'




Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)
// Vue.use(moshaToast)
Vue.use(Toaster, { timeout: 5000 })
Vue.config.productionTip = false

// axios.defaults.baseURL = `http://localhost:1001`
axios.defaults.baseURL = `https://services.ama.id/`

Vue.filter('currencyFormat', function (value) {
  return value.toLocaleString();
});

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyDUbKUKTcAJKsoAA8D7kBqPWqmePHYxL8c',
    libraries: 'places',
  },
  installComponents: true
})

new Vue({
  router,
  vuetify,
  render: h => h(App)
}).$mount('#app')
